import { api } from '@/services/api/main/axios';
import config from '@/config';

export interface ForgotPasswordForm {
  email: string;
  recaptchaResponse: string;
  userId?: string;
}

export interface SetNewPasswordForm {
  password: string;
}

export const forgotPasswordApiRequest = async (form: ForgotPasswordForm) => {
  return api.post('auth/forgot-password', {
    ...form,
    site_id: config.api.site_id,
  });
};

export const setNewPasswordApiRequest = async (form: SetNewPasswordForm) => {
  return api.put('auth/forgot-password', form, {
    meta: { ignoreInterceptor: true },
  } as any);
};
